module.exports = __webpack_public_path__ + "img/product11.6bf32496.jpg";